import React from 'react'
import {
    Container,
    List, Segment,
} from 'semantic-ui-react'
import {reactLocalStorage} from "reactjs-localstorage";
const FixedMenuLayoutFooter = () => (

       <footer>
        <Segment inverted vertical style={{ margin: '2em 0em 0em' }}>
            <Container textAlign='center' divided>
                <List horizontal inverted divided clearing link size='large'>
                    <List.Item as='a' href='#'>
                        Site Map
                    </List.Item>
                    <List.Item as='a' href='#'>
                        Contact Us
                    </List.Item>
                    <List.Item as='a' href='#'>
                        Terms and Conditions
                    </List.Item>
                    <List.Item as='a' href='#'>
                        Privacy Policy
                    </List.Item>
                </List>
            </Container>
        </Segment>
       </footer>



)

export default FixedMenuLayoutFooter
